import { useEffect, useCallback } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import BlockIcon from "@mui/icons-material/Block";
import { useAuth } from "../../contexts/AuthContext";
import { useGetCurrentUserProfile } from "../../api/generated/generated";
import hanoverLogo from "../../assets/hanover.jpg";

export function AccountRejectedPage() {
  const { signOut, refreshToken } = useAuth();
  const { data } = useGetCurrentUserProfile();
  const rejectionReason = data?.data?.rejection_reason;

  const handleFocus = useCallback(() => {
    refreshToken();
  }, [refreshToken]);

  useEffect(() => {
    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [handleFocus]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper sx={{ p: 4, textAlign: "center", width: "100%" }}>
          <Box sx={{ mb: 3 }}>
            <img src={hanoverLogo} alt="Hanover Coach" style={{ height: 48 }} />
          </Box>

          <BlockIcon sx={{ fontSize: 48, color: "error.main", mb: 2 }} />

          <Typography variant="h5" gutterBottom>
            Account Not Approved
          </Typography>

          <Typography
            sx={{
              color: "text.secondary",
              mb: 1
            }}>
            Your account request was not approved.
          </Typography>

          {rejectionReason && (
            <Typography
              sx={{
                color: "text.secondary",
                mb: 1,
                fontStyle: "italic"
              }}>
              Reason: {rejectionReason}
            </Typography>
          )}

          <Typography
            sx={{
              color: "text.secondary",
              mb: 3
            }}>
            Contact your administrator if you believe this is an error.
          </Typography>

          <Button variant="outlined" onClick={signOut}>
            Log Out
          </Button>
        </Paper>
      </Box>
    </Container>
  );
}
